import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionCustom } from "../../../api/transaction-type";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  salesOrderFAMDepreciationHistoryTable,
  salesOrderFamAssetTable,
  salesOrderCustomJournalRejectReasonTable,
  purchaseOrderFamAssetTable,
  purchaseOrderCustomJournalRejectReasonTable,
  purchaseOrderFAMDepreciationHistoryTable,
} from "../../../config/grid-column-defs";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab,
  MenuItem,
  Select,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function PurchaseOrderCustom() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    if (user.token) {
      getTransactionCustomData();
    }
  }, []);

  async function getTransactionCustomData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustom(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data[0]);
      setLoading(false);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox">
      <Grid container spacing={1}>
             {/* <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked={(rowData?.project_sigma_transaction === "" || rowData?.project_sigma_transaction === "F" )? false : true}  />}
                        label="PROJECT SIGMA TRANSACTION"
                      />
                    </FormGroup>
                  </Grid> */}
                   <Grid item xs={12} sm={4} md={4} className="m-b-10">
            <p className="tFormlabel">GP TRANSACTION ID</p>
            <p className="tFormName">{rowData?.gp_transaction_id}</p>
          </Grid>
          <Grid item xs={12} sm={4} md={4} className="m-b-10">
            <p className="tFormlabel">VB SPECIAL MAIL INSTRUCTIONS</p>
            <p className="tFormName">{rowData?.gp_transaction_id}</p>
          </Grid>

        
            <Grid item xs={12} sm={12} md={12} className="m-b-10">
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.project_sigma_transaction !== "" &&
                        rowData?.project_sigma_transaction !== "F"
                      }
                    />
                  }
                  label="GP 3.4M ENTRY TRANSACTION"
                />
              </FormGroup>

              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        rowData?.project_sigma_transaction !== "" &&
                        rowData?.project_sigma_transaction !== "F"
                      }
                    />
                  }
                  label="OPEN AP TRANSACTION 12/31"
                />
              </FormGroup>
            </Grid>
          <Grid item xs={12} sm={4} md={4} className="m-b-10">
              <p className="tFormlabel">PC/PROJECT EVP</p>
              <p className="tFormName">{rowData?.openair_expense_report_number}</p>
            </Grid>
          {/* <Grid item xs={12} sm={4} md={4} className="m-b-10">
            <p className="tFormlabel"></p>
            <p className="tFormName"></p>
        </Grid> */}
        </Grid>
      </Box>
      <Box>
        <Box
          px={2}
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="FAM Asset" />
            <Tab label="Journal Reject Reason" />
            <Tab label="FAM Depreciation History" />
          </Tabs>
          <TabPanel value={tabIndex} index={0}>
            {/*FAM Asset*/}
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Alternate Depreciation History">
                        Alternate Depreciation History
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Default View">Default View</MenuItem>
                      <MenuItem value="Depreciation History">
                        Depreciation History
                      </MenuItem>
                      <MenuItem value="FAM Accounting Method">
                        FAM Accounting Method
                      </MenuItem>
                      <MenuItem value="FAM Depreciation Method 1">
                        FAM Depreciation Method 1
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM ASSET
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM DEPRECIATION HISTORY"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New FAM Asset
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={purchaseOrderFamAssetTable}
              perPage={5}
              refreshCounter={0}
            />
            {/*FAM Asset History*/}
          </TabPanel>
          {/*Journal Reject Reason*/}
          <TabPanel value={tabIndex} index={1}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Custom Default View">
                        Custom Default View
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      JOURNAL REJECT REASON
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="JOURNAL REJECT REASON"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New journal Reject Reason
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={purchaseOrderCustomJournalRejectReasonTable}
              refreshCounter={0}
            />
          </TabPanel>
          {/*FAM Depreciation History*/}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Custom Default View">
                        Default View
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">
                      FAM DEPRECIATION HISTORY
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="FAM Depreciation History"
                    >
                      <MenuItem value="list">List</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#bbd9e8",
                p: 1,
              }}
            >
              <Stack spacing={2} direction="row">
                <Button className="blue-button capitalize">
                  New FAM Depreciation Reason
                </Button>
                <Button className="blue-button">Attach</Button>
                <Button className="blue-button">Customize View</Button>
              </Stack>
            </Box>
            <AgGridPaginatedTable
              getTableRows={getTransactionCustomData}
              columns={purchaseOrderFAMDepreciationHistoryTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
